module.exports = __webpack_public_path__ + "static/media/programmers-header-reverse.37a835ed.svg";